import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { InstanceType } from '@iwentsourcing/core/management/instance-type.js';
import { StreamArgs } from './stream-args.js';
import { optional } from '@iwentsourcing/core/typing/optional.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';
import { SortDirection } from './sort-direction.js';
import { boolean } from '@iwentsourcing/core/typing/boolean.js';
import { number } from '@iwentsourcing/core/typing/number.js';
import { record } from '@iwentsourcing/core/typing/record.js';

export const StateIndexBrowse = object('StateIndexBrowse', {
  realm: string(),
  tenant: string(),
  version: string(),
  pattern: string(),
  state: string(),
  type: InstanceType,
  args: StreamArgs,
  index: string(),

  filter: optional(record(string(), StateValue)),
  bookmark: optional(record(string(), StateValue)),
  direction: optional(SortDirection),
  open: optional(boolean()),
  take: optional(number()),

  token: optional(string()),
});
